<c-flexible-view configuration="flexViewConfig">
    <c-risk-navigation>
    <div ng-controller="riskController as riskCtrl">
        <c-auto-form></c-auto-form>
        </div>
    </c-risk-navigation>
</c-flexible-view>